import { SnippetHighlightingTag } from "../models/highlighting/SnippetHighlightingTag";

export const expansionTags: Array<SnippetHighlightingTag> = [
    {
        ID: 1,
        Name: "Expansion",
        Colour: "#c3caf6",
    },
];
